module.exports = __webpack_public_path__ + "img/s8-qa3.7fb75252.png";